{
  "accountScreen": {
    "downloadCta": "I-download ang Nilagdaang Dokumento",
    "helpDescription": "Mag-email sa amin sa <underline>{{email}}</underline>",
    "helpTitle": "Kailangan ng Tulong o May mga Tanong?",
    "loggedInWith": "Naka-log in gamit ang {{method}}",
    "title": "Account",
    "usernameLoginMethod": "Username"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "Magdagdag ng Isa Pa",
    "addingMemberDescription": "Nais naming malaman kung sino-sino ang mga kasama mo sa bahay.",
    "addingMemberTitle": "Ikwento mo sila sa amin",
    "age": "Edad",
    "coverageCheck": {
      "dateOfBirth": "Petsa ng kapanganakan (kung mayroon)",
      "description": "Opsyonal. Nakakatulong ito para mahanap ang insurance na maaaring mayroon na sila.",
      "medicaidId": "Medicaid ID (kung mayroon)",
      "medicaidIdPlaceholder": "Ilagay ang Medicaid ID",
      "ssn": "SSN (kung mayroon)",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "Tulungan kaming suriin ang kanilang insurance"
    },
    "duplicateDialog": {
      "cancel": "Hindi, bumalik",
      "checkError": "Hindi namin masuri ang mga miyembro ng iyong sambahayan. Pakisubukan muli.",
      "confirm": "Oo, ibang tao",
      "description": "Naidagdag mo na si <bold>{{name}}</bold>. Ibang tao ba ang idinaragdag mo ngayon?",
      "descriptionWithDetails": "Naidagdag mo na si <bold>{{name}}</bold> ({{details}}). Ibang tao ba ang idinaragdag mo ngayon?",
      "reminder": "Hindi mo kailangang idagdag muli ang sinumang naidagdag mo na.",
      "title": "Ibang tao ba ito?"
    },
    "enterDateOfBirth": "Ilagay na lang ang petsa ng kapanganakan",
    "enterRelationship": "Ilagay ang relasyon",
    "firstName": "Pangalan",
    "formSubmission": {
      "error": "Hindi namin maidadagdag ang miyembrong iyon. Pakisubukan muli.",
      "success": "Matagumpay na naidagdag si {{firstName}}"
    },
    "lastName": "Apelyido",
    "livingWithMe": "Kasama ko sa bahay",
    "relationshipToMe": "Relasyon sa akin",
    "sameMailingAddress": "Pareho ang address para sa sulat",
    "updateFormSubmission": {
      "success": "Matagumpay na na-update si {{firstName}}"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "Pakilagay ang iyong edad o birthday.",
      "futureDateOfBirth": "Mangyaring maglagay ng petsa ng kapanganakan sa o bago ang araw na ito.",
      "invalidDateOfBirth": "Maglagay ng valid na birthday (MM/DD/YYYY).",
      "selectAnOption": "Pumili ng opsyon.",
      "specifyRelationship": "Pakilarawan ang relasyon ng taong ito sa iyo."
    }
  },
  "appFooter": {
    "partnershipLabel": "Katuwang ang"
  },
  "appHeader": {
    "toggleThemeTooltip": "Ang Theme Toggle ay pansamantala lang para sa pag-debug. Lalabas lang ito sa local at DEV environments."
  },
  "appMenu": {
    "account": "Account",
    "household": "Sambahayan",
    "language": "Wika",
    "logout": "Logout"
  },
  "applicantDocuments": {
    "alsoCompleted": "Nakumpleto rin ng dokumentong ito ang {{section}}.",
    "alsoCompletedResidenceForMembers": "Nakumpleto rin ng dokumentong ito ang {{section}} para sa mga miyembro ng sambahayan na nakatira sa parehong address",
    "deleteDialog": {
      "description": "Sigurado ka bang gusto mong burahin ang dokumentong ito? Hindi na ito mababawi.",
      "title": "Burahin ang Dokumento"
    },
    "deleteToast": {
      "error": "Hindi namin mabura ang dokumentong iyon. Pakisubukan muli.",
      "success": "Matagumpay na nabura ang dokumento"
    },
    "immigrationIncomplete": {
      "description": "Kailangan mo pa ring mag-upload ng USCIS ID, mga dokumento o pagpapatibay sa immigration, o I-20 para makumpleto ang {{section}}.",
      "dismiss": "Nakuha ko",
      "title": "Kailangan pa ng isang dokumento"
    },
    "optional": "Opsyonal",
    "progress": "{{completeCount}} ng {{applicableCount}} ang tapos na",
    "selectDocumentType": "Pumili ng Uri ng Dokumento",
    "ssn": {
      "cardOption": "O mag-upload ng iyong Social Security card",
      "label": "Social Security Number",
      "save": "I-save",
      "saveError": "Hindi namin ma-save ang numerong iyon. Pakisubukan muli.",
      "saved": "Na-save ang Social Security Number"
    },
    "supportedFiles": "Mga uri ng file: PDF, JPG, PNG",
    "upload": {
      "failed": "Hindi ma-upload ang dokumentong ito. Pakisubukan muli.",
      "failedDescription": "Hindi namin mabasa ang file na ito. Pakitanggal ito at mag-upload ng bago.",
      "uploading": "Nag-uupload..."
    },
    "uploadOne": "Mag-upload ng <bold>kahit isa:</bold>"
  },
  "applicationAddressScreen": {
    "description": "Pakisuri at kumpirmahin ang address ng bahay at tirahan para sa lahat ng kasama sa bahay.",
    "homeAddress": "Address ng Bahay",
    "isHomeless": "Walang Permanenteng Address",
    "mailingAddress": "Address para sa Sulat",
    "needsHomeAddress": "<italic>Kailangan ng Address ng Bahay</italic>",
    "needsMailingAddress": "<italic>Kailangan ng Address para sa Sulat</italic>",
    "noMailingAddress": "Walang Address para sa Sulat",
    "sameHomeAddress": "Parehong address ng bahay",
    "sameMailingAddress": "Parehong address para sa sulat",
    "title": "Impormasyon sa Address",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "address ng bahay",
      "addressTypeHomeAndMailing": "address ng bahay at para sa sulat",
      "addressTypeMailing": "address para sa sulat",
      "description_one": "{{householdName}} at {{count}} iba pa ang kasalukuyang nagbabahagi ng iyong {{addressType}}. Gusto mo bang i-update din ang kanila?",
      "description_other": "{{householdName}} at {{count}} iba pa ang kasalukuyang nagbabahagi ng iyong {{addressType}}. Gusto mo bang i-update din ang kanila?",
      "description_zero": "{{householdName}} ang kasalukuyang nagbabahagi ng iyong {{addressType}}. Gusto mo bang i-update din ang kanila?",
      "onlyUpdateMine": "Hindi, i-update lamang ang akin",
      "title": "I-update ang mga address ng bahay",
      "updateMembers_one": "I-update ang {{count}} miyembro",
      "updateMembers_other": "I-update ang {{count}} miyembro"
    },
    "you": "{{name}} (Ikaw)"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "Ang mga bata ay dapat <bold>kasama sa bahay</bold> nang <bold>mahigit kalahati ng taon</bold> at ang kasama sa bahay ang dapat <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos sa taon</bold> (pagkain, tirahan, pag-aaral, at bayad sa medikal). Kasama rito ang mga hindi kadugo.",
    "title": "Ang mga sumusunod ba na kasama sa bahay ay may inaalagaang bata na wala pang 19 taong gulang?"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "Lahat ba ng mga nasa <bold>{{householdMembersNames}}</bold> ay U.S. Citizens?",
    "hintDescription": "Kung pipiliin ang <bold>Hindi</bold>, huwag mag-alala. May iba pang opsyon para sa programa batay sa immigration status.",
    "noDescription": "Ang ilan o lahat ay hindi U.S. Citizen",
    "title": "Pagiging Kwalipikado sa Application",
    "yesDescription": "Lahat ng nakalista ay U.S. Citizen"
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "Piliin ang “Oo, ikonekta ako” para matulungan kang manatili sa iyong mga doktor at masakop ang iyong pamilya sa iisang lugar.",
      "summaryWithMedicaid": "Susuriin namin ang iyong Medicaid application at makikipag-ugnayan kami kung may kailangan. Kakailanganin mo pa rin ang lisensyadong insurance agent para tapusin ang pag-enroll sa {{programs}}.",
      "summaryWithoutMedicaid": "Nasa amin na ang isinumite mo. Kakailanganin mo pa rin ang lisensyadong insurance agent para tapusin ang pag-enroll sa {{programs}}.",
      "title": "Pinili mong huwag kumonekta sa isang lisensyadong insurance agent. Sigurado ka ba?"
    },
    "continueButton": "Magpatuloy",
    "description": "Susuriin ng aming team ang iyong mga application at makikipag-ugnayan kami kung may kailangan. Kapag maayos na ang lahat, ipapadala namin ang mga ito sa mga programang pinili mo.",
    "title": "Natanggap namin ang iyong mga application!"
  },
  "applicationCoverageStatusScreen": {
    "description": "Mayroon bang health insurance o coverage ang <bold>{{householdMembersNames}}</bold>? Isama ang coverage na malapit nang magsimula.",
    "noDescription": "Walang sinuman ang may insurance",
    "pleaseSpecify": "Pakitukuyin",
    "title": "Katayuan ng Insurance",
    "whatType": "Anong uri ng insurance?",
    "who": "Sino ang may insurance?",
    "yesDescription": "Mayroong may insurance"
  },
  "applicationDateOfBirthScreen": {
    "description": "Pakidagdag at kumpirmahin para sa lahat ng kasama sa bahay",
    "success": "Naitabi na ang lahat ng petsa ng kapanganakan",
    "title": "Petsa ng Kapanganakan"
  },
  "applicationDocuments": {
    "description": "Gagamitin namin ang mga dokumentong ito para kumpirmahin ang mga detalye sa iyong application. Maaari kang mag-upload ngayon o bumalik mamaya.",
    "title": "Mag-upload ng mga Dokumento"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "Magdagdag ng Iba Pang Gastos",
    "addExpense": "Magdagdag ng Gastos",
    "description": "Magdagdag ng mga gastusing medikal at deductible para sa bawat kasama sa bahay.",
    "expenseTypes": {
      "ALIMONY_PAID": "Bayad sa Alimony",
      "CHILDCARE": "Pag-aalaga ng Bata",
      "IRA_CONTRIBUTIONS": "Kontribusyon sa IRA",
      "MEDICAL_EXPENSES": "Gastos sa Medikal",
      "MOVING_EXPENSES": "Gastos sa Paglipat ng Bahay",
      "NONE": "Wala",
      "OTHER": "Iba pa",
      "STUDENT_LOANS": "Student Loans",
      "TUITION_FEES": "Bayad sa Eskwela (Tuition)"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "Hihilingin namin na mag-upload ka ng patunay ng gastos na ito mamaya, kaya ihanda ang mga dokumento. Maaaring kasama rito ang mga billing sa ospital o resibo mula sa botika.",
        "OTHER": "Hihilingin namin na mag-upload ka ng patunay ng gastos na ito mamaya, kaya ihanda ang mga dokumento.",
        "STUDENT_LOANS": "Hihilingin namin na mag-upload ka ng patunay ng gastos na ito mamaya, kaya ihanda ang mga dokumento. Maaaring kasama rito ang student loan statements o award letters mula sa eskwelahan."
      },
      "medicalExpenses3MonthsHelpNeededStatus": "Mayroon ka bang mga gastusing medikal sa nakalipas na 3 buwan na kailangan mo ng tulong sa pagbabayad?",
      "title": "Pumili ng Gastos"
    },
    "monthlyExpense": "{{monthlyExpense}} / buwan",
    "progress": "Status: {{progress}} ng {{total}} ang tapos na",
    "title": "Gastos ng Sambahayan"
  },
  "applicationFlow": {
    "amountPerMonth": "Halaga bawat buwan"
  },
  "applicationForm": {
    "applyingToCounter": "Nag-aapply sa {{programsCount}} para sa {{householdMembersCount}} tao",
    "continueButton": "Magpatuloy sa mga Application",
    "greatNews": "Magandang Balita!",
    "letsCreateApplications": "Gumawa tayo ng mga application para sa lahat.",
    "mayBeEligible": "Maaaring maging kwalipikado si <bold>{{names}}</bold>",
    "mayBeEligibleFor": "Maaaring maging kwalipikado si {{memberNames}} sa <bold>{{brand}}</bold>",
    "notEligible": "Hindi kwalipikado sa ngayon",
    "programConflictDialog": {
      "description": "Ang pag-aplay sa {{newProgram}} ay mag-aalis sa aplikasyon sa {{currentPrograms}} para sa {{memberNames}}. Hindi puwedeng mag-aplay si {{memberNames}} sa dalawa nang sabay. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa si {{memberNames}}.",
      "description_members": "Ang pag-aplay sa {{newProgram}} ay mag-aalis sa mga aplikasyon sa {{currentPrograms}} para sa {{memberNames}}. Hindi puwedeng mag-aplay sina {{memberNames}} sa dalawa nang sabay. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa sina {{memberNames}}.",
      "description_self": "Ang pag-aplay sa {{newProgram}} ay mag-aalis sa iyong aplikasyon sa {{currentPrograms}}. Hindi ka puwedeng mag-aplay sa dalawa nang sabay. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa ka.",
      "keepButton": "Panatilihin ang {{currentPrograms}}",
      "multipleDescription": "Ang pag-aplay sa {{newProgram}} ay mag-aalis sa mga aplikasyon sa {{currentPrograms}} para sa {{memberNames}}. Hindi puwedeng mag-aplay si {{memberNames}} sa lahat ng ito nang sabay. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa si {{memberNames}}.",
      "multipleDescription_members": "Ang pag-aplay sa {{newProgram}} ay mag-aalis sa mga aplikasyon sa {{currentPrograms}} para sa {{memberNames}}. Hindi puwedeng mag-aplay sina {{memberNames}} sa lahat ng ito nang sabay. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa sina {{memberNames}}.",
      "multipleDescription_self": "Ang pag-aplay sa {{newProgram}} ay mag-aalis sa iyong mga aplikasyon sa {{currentPrograms}}. Hindi ka puwedeng mag-aplay sa lahat ng ito nang sabay. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa ka.",
      "recommendMedicaidDescription": "Hindi puwedeng mag-aplay si {{memberNames}} sa dalawa nang sabay. Libre ang Medicaid at kuwalipikado rito si {{memberNames}}. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa si {{memberNames}}.",
      "recommendMedicaidDescription_members": "Hindi puwedeng mag-aplay sina {{memberNames}} sa dalawa nang sabay. Libre ang Medicaid at kuwalipikado rito sina {{memberNames}}. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa sina {{memberNames}}.",
      "recommendMedicaidDescription_self": "Hindi ka puwedeng mag-aplay sa dalawa nang sabay. Libre ang Medicaid at kuwalipikado ka rito. Kapag nag-submit ka, sisiguraduhin naming nasa tamang programa ka.",
      "recommendMedicaidTitle": "Inirerekomenda naming mag-aplay sa Medicaid",
      "switchButton": "Lumipat sa {{newProgram}}",
      "title": "Isang programa lang ang puwede mong aplayan"
    },
    "programsFound": "Nakahanap kami ng {{programsCount}} na programang kwalipikado para sa lahat ng {{householdMembersCount}} kasama sa bahay.",
    "recentDuplicateDialog": {
      "continueAnyway": "Magpatuloy pa rin",
      "description": "Kamakailan ay nagsumite ka ng aplikasyon sa <bold>{{applicationType}}</bold> para kina {{memberNames}}. Dapat ka lamang magsumite ng panibagong aplikasyon kung may nagbago.",
      "multipleDescription": "Kamakailan ay nagsumite ka ng mga aplikasyon sa <bold>{{applicationTypes}}</bold> para kina {{memberNames}}. Dapat ka lamang magsumite ng panibagong aplikasyon kung may nagbago.",
      "title": "Kamakailan ay nagsumite ka ng aplikasyon"
    },
    "startButton": "Simulan ang mga Application"
  },
  "applicationMaritalStatusScreen": {
    "description": "Inayos namin ang marital status batay sa relasyon ng iyong pamilya. Pakisuri at i-update kung kailangan.",
    "needsMaritalStatus": "Kailangan ang katayuang sibil",
    "title": "Kasalukuyang Marital Status"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "American Indian o Alaska Native",
      "needsHelpDailyActivities": "Kailangan ng tulong sa pang-araw-araw na gawain",
      "studentFullTime18to20": "Full-time na estudyante (edad 18 - 20)",
      "veteranOrMilitaryMember": "Beterano o miyembro ng militar"
    },
    "description": "Pakipili ang anumang sitwasyon na nararanasan ng mga kasama sa bahay.",
    "errors": {
      "unableToUpdateHouseholdMembers": "Hindi namin ma-save ang mga pagbabago. Pakisubukan muli."
    },
    "title": "Iba Pang Katayuan"
  },
  "applicationSection": {
    "applications": "Mga Application",
    "beginYourApplicationCompact": "Mag-apply sa loob ng 15 minuto o mas mabilis pa",
    "beginYourApplicationProcess": "Simulan ang proseso at kumuha ng insurance sa loob ng 15 minuto o mas mabilis pa",
    "continueQuickApply": "Ituloy ang Quick Apply",
    "continueYourApplicationCompact": "Ituloy ang iyong aplikasyon",
    "continueYourApplicationProcess": "Ituloy ang proseso at kumuha ng insurance sa loob ng 15 minuto o mas mabilis pa",
    "newQuickApply": "Bagong Quick Apply",
    "quickApply": "Quick Apply"
  },
  "applicationSubmitScreen": {
    "description": "Natapos mo na ang lahat ng hakbang. Kapag handa ka na, i-submit ang mga application sa ibaba.",
    "hintMessage": "Hindi na maaaring baguhin ito pagkatapos i-submit, kaya siguraduhing tama ang lahat.",
    "partialFailure": "Maaaring hindi naipadala ang ilan sa iyong mga insurance application. Pakisuri ang mga ito sa iyong listahan.",
    "submitButton": "I-submit ang mga Application",
    "success": "Matagumpay na na-submit ang mga application.",
    "title": "Ayos Na Ang Lahat!"
  },
  "applicationTaxInformationScreen": {
    "description": "Batay sa impormasyong ibinahagi mo, naniniwala kaming ito ang tax status ng lahat. Pakisuri at i-update kung kailangan.",
    "errors": {
      "unableToUpdateRelationship": "Hindi namin ma-update ang relasyong iyon. Pakisubukan muli."
    },
    "memberCard": {
      "dependentOf": "Dependent ni: {{name}}",
      "dependents": "Mga Dependent: {{name}}",
      "memberDialog": {
        "description": "Suriin at i-update ang mga detalye sa buwis ng taong ito kung kailangan.",
        "saveAndReturn": "I-save at Bumalik",
        "taxClaimedAsDependentStatus": "May magdedeklara ba sa taong ito bilang dependent?",
        "taxDependentsClaimedStatus": "May idedeklara bang mga dependent ang taong ito?",
        "taxFilingStatus": "Katayuan sa Buwis (Tax Status)",
        "title": "Impormasyon sa Buwis – {{name}}",
        "who": "Sino?"
      }
    },
    "needsTaxInformation": "Kailangan ng impormasyon sa buwis",
    "success": "Matagumpay na na-update ang impormasyon sa buwis",
    "title": "Impormasyon sa Buwis"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "Magdagdag ng Iba Pang Kita",
    "addIncome": "Magdagdag ng Kita",
    "description": "Magdagdag ng impormasyon sa trabaho at kita para sa bawat kasama sa bahay.",
    "incomeTypes": {
      "ALIMONY": "Alimony",
      "EMPLOYED": "May Trabaho",
      "NONE": "Wala",
      "OTHER": "Iba pa",
      "PENSION": "Pension",
      "PROPERTY_RENTAL_INCOME": "Kita sa pagpapa-upa",
      "RETIREMENT_INCOME": "Kita mula sa retirement",
      "SELF_EMPLOYED": "Self-employed",
      "SSA": "SSA",
      "SSDI": "SSDI",
      "UNEMPLOYED": "Walang Trabaho",
      "WORKERS_COMPENSATION": "Worker's compensation"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "Hihilingin namin na mag-upload ka ng patunay ng kita mamaya. Ihanda ang mga paystub o W-2 forms.",
        "OTHER": "Hihilingin namin na mag-upload ka ng patunay mamaya. Maaaring award letters o benefit statements.",
        "SELF_EMPLOYED": "Hihilingin namin na mag-upload ka ng patunay mamaya gaya ng mga invoice o 1099 forms.",
        "UNEMPLOYED": "Hihilingin namin na mag-upload ka ng patunay mamaya gaya ng award letters o benefit statements."
      },
      "employerName": "Pangalan ng Employer",
      "enterName": "Ilagay ang pangalan",
      "enterTypeOfWork": "Ilagay ang uri ng trabaho",
      "grossMonthlyIncome": "Buwanang kita bago ang buwis (Gross)",
      "payFrequency": "Dalas ng pagpapasahod",
      "selfEmploymentNetMonthlyIncome": "Tinatayang buwanang NET na kita matapos ang mga gastos",
      "title": "Pumili ng Uri ng Kita",
      "typeOfWork": "Uri ng trabaho",
      "unemploymentCompensationStatus": "Tumatanggap ka ba ng unemployment compensation?",
      "workWeekHours": "Oras ng trabaho bawat linggo"
    },
    "monthlyIncome": "{{monthlyIncome}} / buwan",
    "title": "Trabaho at Kita"
  },
  "applicationsListScreen": {
    "applicationDate": "MM/DD/YYYY [nang] h:mm A",
    "inProgress": "Kasalukuyang Pinoproseso",
    "noApplications": "Wala ka pang anumang application.",
    "submitted": "Na-submit na",
    "title": "Mga Application para sa {{applicationType}}"
  },
  "authScreen": {
    "appleSignInFailed": "Hindi ka namin ma-sign in gamit ang Apple. Pakisubukan muli o gumamit ng ibang opsyon.",
    "checkYourEmail": "Suriin ang iyong email",
    "checkYourSpam": "Hindi natanggap? Tingnan ang spam folder o maghintay ng ilang minuto bago sumubok muli.",
    "continueWithApple": "Magpatuloy gamit ang Apple",
    "continueWithGoogle": "Magpatuloy gamit ang Google",
    "dataSecured": "Ligtas ang iyong data sa amin. HIPAA & SOC 2 Compliant.",
    "emailInput": "Email Address",
    "googleSignInFailed": "Hindi ka namin ma-sign in gamit ang Google. Pakisubukan muli o gumamit ng ibang opsyon.",
    "identifierInput": "Email o username",
    "invalidIdentifier": "Maglagay ng wastong email address o username.",
    "subtitle": "Ilagay ang iyong email o username para magpatuloy.",
    "title": "Mag-sign in o Gumawa ng Account",
    "weSentALink": "Nagpadala kami ng ligtas na link sa <bold>{{email}}</bold>. I-click ang link para magpatuloy.",
    "youAgree": "Sa pagpapatuloy, sumasang-ayon ka sa aming <underline><colorEmphasis>Terms of Service</colorEmphasis></underline> at <privacyLink><colorEmphasis>Privacy Policy</colorEmphasis></privacyLink>."
  },
  "brokerConsent": {
    "noButton": "Hindi na, salamat",
    "recommendedBadge": "Inirerekomenda",
    "yesButton": "Oo, ikonekta ako"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "Magpatuloy sa Medicaid lang",
    "continueWithoutAgentButton": "Magpatuloy nang walang ahente",
    "declineCard": {
      "applyLink": "Mag-apply sa {{program}}",
      "fallbackWithMedicaid": "Puwede mo pa ring ituloy ang iyong Medicaid application dito. Kaya ng Pointcare na asikasuhin ang iyong Medicaid application nang walang ahente.",
      "fallbackWithoutMedicaid": "Puwede mo pa ring ituloy ang iyong application dito. Ang pagtapos ngayon ay nangangahulugang matutulungan ka ng Pointcare kapag nagbago ang mga pangangailangan mo sa coverage.",
      "selfEnrollmentWarning": "Kung walang ahente, kailangan mong mag-enroll sa {{programs}} nang mag-isa.",
      "title": "Piliin ang “Oo, ikonekta ako” para masulit ang Pointcare"
    },
    "subtitle": "Ikokonekta ka namin kapag oras na para mag-enroll, at ibabahagi lang ang kailangan para makatulong.",
    "subtitleWithIndividual": "Ikokonekta ka namin kapag oras na para mag-enroll, at ibabahagi lang ang kailangan para makatulong. Kung nag-a-apply ka para sa Medicare, ang ahenteng ito ay {{brokerName}}.",
    "subtitleWithIndividualLicense": "Ikokonekta ka namin kapag oras na para mag-enroll, at ibabahagi lang ang kailangan para makatulong. Kung nag-a-apply ka para sa Medicare, ang ahenteng ito ay {{brokerName}} (Lisensya #: {{licenseNumber}}).",
    "subtitleWithOrganization": "Ikokonekta ka namin kapag oras na para mag-enroll, at ibabahagi lang ang kailangan para makatulong. Kung nag-a-apply ka para sa Medicare, ang ahenteng ito ay magmumula sa {{brokerName}}.",
    "subtitleWithOrganizationLicense": "Ikokonekta ka namin kapag oras na para mag-enroll, at ibabahagi lang ang kailangan para makatulong. Kung nag-a-apply ka para sa Medicare, ang ahenteng ito ay magmumula sa {{brokerName}} (Lisensya #: {{licenseNumber}}).",
    "title": "Kumonekta sa isang lisensyadong insurance agent para tuklasin ang mga opsyon sa Medicare at/o Marketplace ng ACA at makakuha ng tulong sa pagtatapos ng enrollment"
  },
  "camera": {
    "grantPermission": "Ibigay ang Pahintulot",
    "permissionDescription": "Para makunan ng larawan ang iyong mga dokumento, payagan ang camera access sa settings ng iyong phone.",
    "permissionRequired": "Kailangan namin ng access sa iyong camera.",
    "photoCount": "{{count}} (na) larawan ang nakuha",
    "tapToCapture": "Pindutin ang button para kumuha ng larawan"
  },
  "cesSurvey": {
    "feedbackLabel": "Ano ang naging mahirap?",
    "feedbackPlaceholder": "Sabihin pa sa amin",
    "optionalLabel": "Opsyonal",
    "questions": {
      "consentFormSigned": "Gaano kadali bang maintindihan ang iyong pinipirmahan?",
      "householdMemberAdded": "Gaano kadali bang magdagdag ng miyembro ng sambahayan?",
      "incomeAdded": "Gaano kadali bang magdagdag ng kita?"
    },
    "scoreEasy": "Madali",
    "scoreHard": "Mahirap",
    "scoreOk": "Katamtaman",
    "scoreVeryEasy": "Napakadali",
    "scoreVeryHard": "Napakahirap",
    "thanksDescription": "Nakakatulong ang iyong feedback para mapabuti namin ito.",
    "thanksTitle": "Salamat!"
  },
  "consentDocuments": {
    "addSignature": "Magdagdag ng Lagda",
    "description": "Pumirma sa ibaba para makatulong kami sa iyo.",
    "documentTitle": "Pahintulot na Ibahagi (PDF)",
    "grant1": "Subaybayan ang iyong insurance at ayusin agad ang mga problema",
    "grant2": "Sumagot sa mga hiling para sa iyo - para walang mawala o makalimutang sulat",
    "grant3": "Mag-submit ng mga application at renewal, at mag-follow up para hindi makalampas sa deadline",
    "grant4": "Makipag-ugnayan sa iyo para sa mga layuning pang-marketing sa pamamagitan ng regular o automated na tawag sa telepono, voice message, at text",
    "grantHealthPlanSelection": "Ilapat ang iyong napiling health plan at doktor (kapag available) sa iyong coverage",
    "grantSubtitle": "Narito ang kasama nito:",
    "healthPlanAvailabilityError": "Hindi namin masuri ang mga available na health plan. Pakisubukang muli bago pumirma.",
    "signatureCountsAsInitials": "Ang iyong lagda ay itinuturing ding iyong inisyal sa form kung saan naaangkop.",
    "title": "Pamamahala ng Insurance ng Iyong Pamilya",
    "viewDocument": "Tingnan ang Dokumento"
  },
  "coverage": {
    "code": "Code:",
    "coverageStatus": "Katayuan ng Insurance",
    "inProgress": "Pinoproseso",
    "isCovered": "Si {{name}} ay may insurance sa {{programs}}.",
    "lastCheck": "Huling pagsusuri",
    "lastCheckDateFormat": "MM/DD/YYYY",
    "lastCheckWithDate": "Huling pagsusuri {{date}}",
    "noMatchingRecord": "Hindi namin mahanap ang iyong coverage. Pakisuri ang iyong impormasyon at subukan muli.",
    "planName": "Pangalan ng plano",
    "primaryCareProvider": "Primary care provider",
    "programCoverage": "Insurance sa {{program}}",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> at <bold>Medicaid</bold>"
    },
    "serviceTypes": "Mga uri ng serbisyo",
    "status": {
      "checking": "Sinusuri ang insurance...",
      "checkingShort": "Sinusuri...",
      "covered": "May Insurance",
      "coveredBy": "May insurance sa {{ programs }}",
      "notCovered": "Walang insurance",
      "unknown": "Hindi alam ang insurance",
      "unknownShort": "Hindi alam"
    },
    "updateProfileInformation": "I-update ang Impormasyon ng Profile"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "Password",
    "passwordInputPlaceholder": "Gumawa ng password",
    "passwordRequirement": "Gumamit ng hindi bababa sa 10 character.",
    "subtitle": "Protektahan ang iyong bagong account gamit ang matibay na password.",
    "title": "Gumawa ng password"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "Password",
    "passwordInputPlaceholder": "Gumawa ng password",
    "subtitle": "Protektahan ang iyong bagong account gamit ang matibay na password.",
    "title": "Gumawa ng password"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "DD",
    "monthPlaceholder": "MM",
    "yearPlaceholder": "YYYY"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "Gamitin ang GROSS na kita (bago ang buwis) para sa karamihan. Kung self-employed, gamitin ang net na kita (matapos ang mga gastos sa negosyo).",
    "description2": "Kasama rito ang tinatayang kita para sa lahat ng kasama sa bahay:",
    "hideBreakdown": "Itago ang breakdown",
    "householdIncomeCalculator": {
      "annualDescription": "Ilagay ang tinatayang taunang kita ng bawat tao para makuha ang kabuuan",
      "biWeeklyDescription": "Ilagay ang kita bawat 2 linggo ng bawat tao",
      "monthlyDescription": "Ilagay ang buwanang kita ng bawat tao",
      "period": {
        "annual": "taon",
        "biWeekly": "2 linggo",
        "monthly": "buwan"
      },
      "title": "Kalkulahin ang iyong kita",
      "totalIncomeTitle": "Kabuuang kita ng sambahayan:",
      "totalIncomeValue": "{{total}} /{{period}}",
      "useRange": "Gamitin ang {{label}}"
    },
    "incomePeriod": {
      "annual": "Taunan",
      "biWeekly": "Kada 2 linggo",
      "monthly": "Buwanan"
    },
    "incomeRange": {
      "0-1800": "₱0 - ₱1,800",
      "0-3700": "₱0 - ₱3,700",
      "0-44400": "₱0 - ₱44,400",
      "1600-2600": "₱1,600 - ₱2,600",
      "2500-3000": "₱2,500 - ₱3,000",
      "3000-3300": "₱3,000 - ₱3,300",
      "3300+": "₱3,300 pataas",
      "3500-5600": "₱3,500 - ₱5,600",
      "43000-67000": "₱43,000 - ₱67,000",
      "5500-6500": "₱5,500 - ₱6,500",
      "6500-7000": "₱6,500 - ₱7,000",
      "66000-78000": "₱66,000 - ₱78,000",
      "7000+": "₱7,000 pataas",
      "78000-83000": "₱78,000 - ₱83,000",
      "83000+": "₱83,000 pataas"
    },
    "showBreakdown": "Kailangan ng tulong sa pagkalkula? Ipakita ang breakdown",
    "title": "Magkano ang tinatayang kita ng iyong sambahayan?",
    "updateError": "Hindi namin ma-save ang iyong kita. Pakisubukan muli."
  },
  "eligibilityHouseholdMembers": {
    "title": "Iyong sambahayan",
    "you": "Ikaw"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "Dapat silang <bold>kasama mo sa bahay</bold> nang <bold>mahigit kalahati ng taon</bold> at dapat ikaw ang <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos sa taon</bold> (pagkain, tirahan, pag-aaral, at bayad sa medikal). Kasama rito ang mga hindi kadugo.",
    "formDescription": "Magdagdag ng sinumang anak, stepchildren, apo, o foster children na wala pang 19 na kasama mo at sinusuportahan mo sa pananalapi.",
    "formTitle": "Ikwento sa amin ang mga batang sinusuportahan mo",
    "supporterDescription": "Dapat silang <bold>kasama ni {{supporterFirstName}}</bold> nang <bold>mahigit kalahati ng taon</bold> at si {{supporterFirstName}} ang dapat <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos sa taon</bold>.",
    "supporterFormDescription": "Magdagdag ng sinumang anak o apo na wala pang 19 na kasama ni {{supporterFirstName}}.",
    "supporterFormTitle": "Ikwento sa amin ang mga anak ni {{supporterFirstName}}",
    "supporterTitle": "Si {{supporterFirstName}} ba ay may kasama at inaalagaang mga bata na wala pang 19 taong gulang?",
    "title": "May kasama ka ba at inaalagaang mga bata na wala pang 19 taong gulang?"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "Nakakatulong ito sa amin na maunawaan ang iyong sambahayan at malaman kung anong mga programa ang kwalipikado ka.",
    "formDescription": "Kailangan namin ng ilang simpleng impormasyon tungkol sa iyong asawa o partner.",
    "formTitle": "Ikwento sa amin ang tungkol sa iyong asawa o partner",
    "supporterFormDescription": "Kailangan namin ng impormasyon tungkol sa asawa o partner ni {{supporterFirstName}}.",
    "supporterFormTitle": "Ikwento sa amin ang asawa o partner ni {{supporterFirstName}}",
    "supporterTitle": "Ano ang marital status ni {{supporterFirstName}}?",
    "title": "Ano ang iyong marital status?"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "Dapat ikaw ang <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos sa taon</bold> (pagkain, tirahan, pag-aaral, at bayad sa medikal).",
    "formDescription": "Magdagdag ng sinumang full-time na estudyante na edad 18–21 kung saan ikaw ang magulang o legal guardian at nagbibigay ng suportang pinansyal.",
    "formTitle": "Ikwento sa amin ang estudyanteng sinusuportahan mo",
    "supporterDescription": "Si {{supporterFirstName}} ang dapat <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos sa taon</bold>.",
    "supporterFormDescription": "Magdagdag ng sinumang full-time na estudyante na edad 18–21 na sinusuportahan ni {{supporterFirstName}}.",
    "supporterFormTitle": "Ikwento sa amin ang estudyanteng sinusuportahan ni {{supporterFirstName}}",
    "supporterTitle": "Si {{supporterFirstName}} ba ang magulang o legal guardian ng isang full-time na estudyante (edad 18-21) na sinusuportahan niya sa pananalapi?",
    "title": "Ikaw ba ang magulang o legal guardian ng isang full-time na estudyante (edad 18-21) na sinusuportahan mo sa pananalapi?"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "Kasama rito ang pagkain, tirahan, pag-aaral, at mga bayad sa medikal.",
    "errors": {
      "updateFailed": "Hindi namin ma-save ang mga pagbabago. Pakisubukan muli."
    },
    "formDescription": "Ipadala ang impormasyon ng tao na nagbibigay ng mahigit kalahati ng iyong suportang pinansyal, gaya ng magulang, guardian, o kamag-anak.",
    "formTitle": "Ikwento sa amin ang taong sumusuporta sa iyo",
    "options": {
      "disabled": "Oo, ako ay may kapansanan at kasama ko sa bahay ang taong sumusuporta sa akin sa buong taon.",
      "fullTimeStudent": "Oo, ako ay isang full-time na estudyante at sinusuportahan ako ng aking magulang o legal guardian.",
      "personSupportsMe": "Oo, kasama ko sa bahay ang taong sumusuporta sa akin nang mahigit kalahati ng taon.",
      "relativeSupportsMe": "Oo, kasama ko sa bahay ang isang kamag-anak na sumusuporta sa akin nang mahigit kalahati ng taon."
    },
    "title": "Mayroon bang nagbibigay ng mahigit kalahati ng iyong taunang suportang pinansyal?"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "Magdagdag ng mga detalye",
    "conditions": {
      "blind": "May bulag sa pamilya",
      "breastCancer": "May may breast cancer",
      "cervicalCancer": "May may cervical cancer",
      "disabled": "May may kapansanan (SSDI)",
      "fosterCare": "May nanggaling sa foster care noong sila ay 18 na",
      "pregnant": "May buntis"
    },
    "description": "Pakipili ang anumang sitwasyon na nararanasan ng mga kasama sa bahay.",
    "errors": {
      "allUpdatesFailed": "Hindi namin ma-save ang mga pagbabago. Pakisubukan muli."
    },
    "pregnancyDetails": {
      "estimatedDueDate": "Tinatayang petsa ng panganganak",
      "numberOfBabies": "Bilang ng inaasahang sanggol",
      "title": "Mga Detalye ng Pagbubuntis"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "{{count}} sanggol • Inaasahan sa {{date}}",
      "babiesWithCount_other": "{{count}} sanggol • Inaasahan sa {{date}}"
    },
    "title": "Mga Espesyal na Sitwasyon sa Iyong Sambahayan"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "Maaari itong kahit sino — anak, kapatid, lolo/lola, o hindi kadugo — kahit anong edad. Dapat ikaw ang <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos sa taon</bold>.",
    "formDescription": "Magdagdag ng mga taong may kapansanan na kasama mo sa bahay at sinusuportahan mo sa pananalapi.",
    "formTitle": "Ikwento sa amin ang taong may kapansanan na sinusuportahan mo",
    "supporterDescription": "Dapat si {{supporterFirstName}} ang <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos sa taon</bold>.",
    "supporterFormDescription": "Magdagdag ng mga taong may kapansanan na kasama at sinusuportahan ni {{supporterFirstName}}.",
    "supporterFormTitle": "Ikwento sa amin ang taong sinusuportahan ni {{supporterFirstName}}",
    "supporterTitle": "Mayroon bang sinusuportahang taong may kapansanan si {{supporterFirstName}} na kasama niya sa bahay?",
    "title": "Mayroon ka bang sinusuportahang taong may kapansanan na kasama mo sa bahay sa buong taon?"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "Dapat silang <bold>kasama mo sa bahay</bold> nang <bold>mahigit kalahati ng taon</bold> at ikaw ang <bold>nagbibigay ng mahigit kalahati</bold> ng kanilang <bold>gastos</bold>. Kasama rito ang mga kamag-anak, step-family, at in-laws.",
    "formDescription": "Magdagdag ng mga kamag-anak, step-family, o in-laws na kasama mo at sinusuportahan mo.",
    "formTitle": "Ikwento sa amin ang mga kamag-anak na sinusuportahan mo",
    "supporterDescription": "Dapat silang <bold>kasama ni {{supporterFirstName}}</bold> nang mahigit kalahati ng taon.",
    "supporterFormDescription": "Magdagdag ng mga kamag-anak na kasama at sinusuportahan ni {{supporterFirstName}}.",
    "supporterFormTitle": "Ikwento sa amin ang mga kamag-anak na sinusuportahan ni {{supporterFirstName}}",
    "supporterTitle": "Mayroon bang ibang kamag-anak na sinusuportahan si {{supporterFirstName}} na kasama niya sa bahay?",
    "title": "Mayroon ka bang ibang kamag-anak na sinusuportahan na kasama mo sa bahay?"
  },
  "homeScreen": {
    "addMember": "Magdagdag ng Kasama",
    "applicationSubmittedCard_multiple": "Nagsumite ka ng mga aplikasyon sa <programs /> para sa {{memberNames}}. Susuriin namin ang mga ito at makikipag-ugnayan kami kung may kailangan kami.",
    "applicationSubmittedCard_single": "Nagsumite ka ng aplikasyon sa <programs /> para sa {{memberNames}}. Susuriin namin ito at makikipag-ugnayan kami kung may kailangan kami.",
    "applicationSubmittedCard_singleMarketplace": "Nagsumite ka ng aplikasyon sa <programs /> para sa {{memberNames}}. Susuriin namin ito at makikipag-ugnayan kami kung may kailangan kami.",
    "checkEligibility": "Suriin ang pagiging Kwalipikado",
    "checkEligibilityCompact": "Suriin ang Pagiging Kwalipikado",
    "devScenarioActive": "Aktibo ang simuladong senaryo — nagpapakita ng test data ang dashboard.",
    "devScenarioReset": "I-reset",
    "eligibilityCardCompactNotStarted": "Alamin kung anong mga programa ang maaaring kwalipikado ka",
    "eligibilityCardCompactStarted": "Magpatuloy para malaman kung anong mga programa ang maaaring kwalipikado ka",
    "eligibilityCardNotStarted": "Simulan ang mabilis na pagsusuri para malaman kung anong mga programa ang kwalipikado ang iyong pamilya",
    "eligibilityCardStarted": "Ituloy ang pagsusuri para malaman kung anong mga programa ang kwalipikado ang iyong pamilya",
    "household": "Sambahayan",
    "logout": "Logout",
    "nextSteps": "Mga susunod na hakbang",
    "recheckEligibility": "Suriin muli ang Kwalipikasyon"
  },
  "householdMemberScreen": {
    "applicantDocuments": "Mga Dokumento ng Aplikante",
    "checkCoverage": "Suriin ang Insurance",
    "deleteButton": "Alisin si {{memberFullName}} sa sambahayan",
    "deleteDialog": {
      "description": "Permanente nitong aalisin si {{memberFullName}} sa iyong sambahayan. Mabubura ang lahat ng kanilang impormasyon at hindi na mababawi.\nHindi na ito mababago.",
      "title": "Alisin ang Kasama sa Bahay"
    },
    "deleteToast": {
      "error": "Hindi namin maalis ang miyembrong iyon. Pakisubukan muli.",
      "success": "Matagumpay na naalis ang kasama sa bahay"
    },
    "profileInformation": "Impormasyon ng Profile"
  },
  "landingScreen": {
    "goToAuth": "Pumunta sa Auth Screen"
  },
  "languageSelectorModal": {
    "title": "Pumili ng Wika"
  },
  "languages": {
    "arabicDescription": "Arabic",
    "chineseSimplifiedDescription": "Chinese Simplified",
    "englishDescription": "English",
    "haitianCreoleDescription": "Haitian Creole",
    "russianDescription": "Russian",
    "spanishDescription": "Spanish",
    "tagalogDescription": "Tagalog",
    "vietnameseDescription": "Vietnamese"
  },
  "memberFormSubmission": {
    "error": "Hindi namin ma-save ang mga pagbabago. Pakisubukan muli.",
    "success": "Matagumpay na na-update ang kasama sa bahay"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "Numero ng Telepono",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "Padadalhan ka namin ng verification code.",
    "subtitle": "Gagamitin namin ito para mapanatiling ligtas ang iyong account.",
    "title": "Ano ang iyong numero ng telepono?"
  },
  "mfaVerifyScreen": {
    "getNewCode": "Kumuha ng bagong code",
    "subtitle": "Pakilagay ang 6-digit code na ipinadala namin sa\n<bold>{{phoneNumber}}</bold>",
    "title": "Nagpadala kami sa iyo ng code",
    "verificationCodeLabel": "Verification Code"
  },
  "notFound": {
    "cta": "Pumunta sa Home",
    "description": "Ang page na hinahanap mo ay wala na rito.",
    "title": "Hindi nahanap ang page."
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "Ano ang pinakanagustuhan mo tungkol sa Pointcare? (opsyonal)",
    "highFeedbackPlaceholder": "Sabihin sa amin kung ano ang namukod-tangi",
    "lowFeedbackLabel": "Ano ang maaari naming pagbutihin? (opsyonal)",
    "lowFeedbackPlaceholder": "Sabihin sa amin kung ano ang hindi naging maayos...",
    "mediumFeedbackLabel": "Ano pa ang kailangan para bigyan mo ito ng 10? (opsyonal)",
    "mediumFeedbackPlaceholder": "Ano ang makakapagpaganda pa nito...",
    "scaleHighLabel": "→ Lubos na malamang",
    "scaleLowLabel": "→ Hindi talaga malamang",
    "submitButton": "Isumite ang feedback",
    "subtitle": "Hindi kailanman ibinabahagi ang iyong mga sagot sa mga programang inapplyan mo.",
    "success": "Matagumpay na naisumite ang feedback.",
    "testimonialLabel": "Maaari ba naming ibahagi ang iyong feedback sa aming website para makatulong sa mas maraming tao na makahanap ng coverage? Gagamitin lang namin ang iyong unang pangalan.",
    "title": "Gaano kalamang na irekomenda mo ang Pointcare sa isang kaibigan o kapamilya?"
  },
  "onboarding": {
    "benefits": {
      "description": "Tinutulungan ng Pointcare ang 1.8M+ na pasyente sa buong U.S. na mahanap at mapanatili ang kanilang health insurance.",
      "firstItem": "Alamin kung sino ang kwalipikado sa loob ng 5 min",
      "firstItem_AGING_INTO_MEDICARE": "Hanapin ang tamang Medicare insurance",
      "firstItem_AGING_INTO_MEDICARE_awareness": "Manatiling updated sa mga timeline",
      "firstItem_LAPSE": "Alamin kung sino ang kwalipikado sa loob ng 5 min",
      "firstItem_QR_CODE": "Alamin kung sino ang kwalipikado sa loob ng 5 min",
      "firstItem_RECURRING_WORK_REQUIREMENT": "Huwag makalampas sa mahalagang deadline",
      "firstItem_REDETERMINATION": "Huwag makalampas sa mahalagang deadline",
      "firstItem_SELF_PAY_CONVERSION": "Alamin kung sino ang kwalipikado sa loob ng 5 min",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "Huwag makalampas sa mahalagang deadline",
      "firstItem_SERVICE_INTRODUCTION_medicare": "Suriin ang mga benepisyo ng lahat sa loob ng 5 min",
      "freeToUse": "Libreng tulong - walang hidden fees",
      "infoIsPrivate": "Anumang impormasyong ibabahagi ay mananatiling pribado",
      "title": "Nakipagtulungan ang {{clinicName}} sa Pointcare para suportahan ang iyong pamilya",
      "titleNoClinic": "Ang Pointcare ay narito para suportahan ang iyong pamilya"
    },
    "buttons": {
      "createMyProfile": "Gumawa ng Aking Profile",
      "getStarted": "Magsimula Na"
    },
    "concerns": {
      "description": "Pumili ng opsyon na pinakaimportante sa iyo — ipakikita namin kung paano kami makakatulong.",
      "description_SERVICE_INTRODUCTION_medicare": "Pumili ng opsyon na naglalarawan sa insurance na ito.",
      "title": "Ano ang pinaka-frustrating para sa iyo sa pagkuha ng insurance para sa pamilya?",
      "title_SERVICE_INTRODUCTION_medicare": "Anong Medicare insurance mayroon ang iyong pamilya?"
    },
    "figuringOutWhenToRenew": {
      "option": "Inaalam kung kailan magre-renew",
      "subtext": "Susubaybayan namin ang mga petsa ng renewal para sa lahat at paalalahanan ka bago mahuli ang lahat."
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "Inaalam kung kailan magpapasa ng requirements",
      "subtext": "Susubaybayan namin ang mga petsa para sa lahat at paalalahanan ka."
    },
    "imNotSure": {
      "option": "Hindi ako sigurado",
      "subtext": "Sisiguraduhin naming maayos pa rin ang plano para sa lahat."
    },
    "intro": {
      "description": "Maraming tao ang walang binabayaran. Ang iba naman ay nasa $20–30 lang bawat buwan. Magtatanong kami ng ilang simpleng bagay para mahanap ang pinakamagandang opsyon.",
      "description_AGING_INTO_MEDICARE": "Maaaring marami kang natatanggap na alok ngayon. Bilang healthcare provider ng pamilya, tutulungan ka naming mahanap ang tamang plano.",
      "description_AGING_INTO_MEDICARE_awareness": "Maaaring marami kang natatanggap na alok ngayon. Bilang healthcare provider ng pamilya, tutulungan ka naming mahanap ang tamang plano.",
      "description_LAPSE": "7 sa 10 tao ang maaaring muling maging kwalipikado para sa libre o murang insurance. Tutulungan ka namin sa bawat hakbang.",
      "description_QR_CODE": "Maraming tao ang walang binabayaran. Ang iba naman ay nasa $20–30 lang bawat buwan.",
      "description_RECURRING_WORK_REQUIREMENT": "Isang bagong batas ang humihingi ng patunay ng kita. Susuriin namin kung exempted ka o nasa tamang track.",
      "description_REDETERMINATION": "Kailangan mong kumpirmahin o i-update ang impormasyon ng sambahayan para mapanatili ang insurance. Tutulungan ka namin.",
      "description_SELF_PAY_CONVERSION": "Maraming tao ang walang binabayaran. Ang iba naman ay nasa $20–30 lang bawat buwan.",
      "description_SERVICE_INTRODUCTION_medicaid": "Babantayan namin ang insurance ng lahat, tutulong sa mga renewal, at gagabay sa kahit anong mangyari — nang libre.",
      "description_SERVICE_INTRODUCTION_medicare": "Tutulungan ka naming maunawaan ang insurance, makahanap ng dagdag na benepisyo, at masiguradong wala kang makakaligtaan.",
      "title": "Hindi dapat mahirap ang kumuha ng health insurance. Maaaring kwalipikado ang iyong pamilya para sa <colorEmphasis>libre o murang mga plano</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE": "Mukhang may kasama sa pamilya na naging kwalipikado sa Medicare sa loob ng <colorEmphasis>{{count}} (na) buwan</colorEmphasis>. Narito kami para tumulong.",
      "title_AGING_INTO_MEDICARE_awareness_one": "Mukhang may kasama sa pamilya na magiging kwalipikado sa Medicare sa loob ng <colorEmphasis>{{monthsToTurning65}} (na) buwan</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_awareness_other": "Mukhang may kasama sa pamilya na magiging kwalipikado sa Medicare sa loob ng <colorEmphasis>{{monthsToTurning65}} (na) buwan</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_one": "Mukhang may kasama sa pamilya na naging kwalipikado sa Medicare sa loob ng <colorEmphasis>{{count}} (na) buwan</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_other": "Mukhang may kasama sa pamilya na naging kwalipikado sa Medicare sa loob ng <colorEmphasis>{{count}} (na) buwan</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_zero": "Mukhang may kasama sa pamilya na naging kwalipikado sa Medicare <colorEmphasis>ngayong buwan na ito</colorEmphasis>.",
      "title_LAPSE": "Mukhang may kasama sa pamilya na nawalan ng {{payerName}} coverage noong <colorEmphasis>{{lapseDate}}</colorEmphasis>.",
      "title_QR_CODE": "Maaaring kwalipikado ang iyong pamilya para sa <colorEmphasis>libre o murang health insurance</colorEmphasis>.",
      "title_RECURRING_WORK_REQUIREMENT_one": "Mukhang may kasama sa pamilya na may {{payerName}} work requirement sa loob ng <colorEmphasis>{{count}} buwan</colorEmphasis>.",
      "title_RECURRING_WORK_REQUIREMENT_other": "Mukhang may kasama sa pamilya na may {{payerName}} work requirement sa loob ng <colorEmphasis>{{count}} buwan</colorEmphasis>.",
      "title_RECURRING_WORK_REQUIREMENT_zero": "Mukhang may kasama sa pamilya na may {{payerName}} work requirement <colorEmphasis>ngayong buwan na ito</colorEmphasis>.",
      "title_REDETERMINATION_one": "Mukhang may kasama sa pamilya na may {{payerName}} renewal sa loob ng <colorEmphasis>{{count}} buwan</colorEmphasis>.",
      "title_REDETERMINATION_other": "Mukhang may kasama sa pamilya na may {{payerName}} renewal sa loob ng <colorEmphasis>{{count}} buwan</colorEmphasis>.",
      "title_REDETERMINATION_zero": "Mukhang may kasama sa pamilya na may {{payerName}} renewal <colorEmphasis>ngayong buwan na ito</colorEmphasis>.",
      "title_SERVICE_INTRODUCTION_medicaid": "Narito kami para tulungan ang iyong pamilyang <colorEmphasis>manatiling may insurance sa {{payerName}}.</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "Nakukuha ba ng iyong pamilya ang <colorEmphasis>pinakasulit mula sa {{payerName}}?</colorEmphasis>"
    },
    "keepingMyCurrentDoctors": {
      "option": "Pagpapanatili ng kasalukuyang mga doktor",
      "subtext": "Tutulungan ka naming mahanap ang plano na kasama ang mga doktor ng iyong pamilya."
    },
    "meetingRequirements": {
      "option": "Pagpuno sa mga requirements",
      "subtext": "Tutulungan namin ang lahat pagdating sa pagpasa ng mga work requirements."
    },
    "missingEnrolmentDeadline": {
      "option": "Paglampas sa deadline ng enrollment",
      "subtext": "Sisiguraduhin naming alam mo kung kailan mag-eenroll para maiwasan ang multa."
    },
    "nextSteps": {
      "step1Description": "Ikwento ang tungkol sa iyong sarili",
      "step1Duration": "2 min",
      "step1Title": "Gumawa ng Profile",
      "step2Description": "Insurance na kwalipikado ang iyong pamilya",
      "step2Description_AGING_INTO_MEDICARE": "Suriin ang kasalukuyang katayuan",
      "step2Description_AGING_INTO_MEDICARE_awareness": "Suriin ang kasalukuyang katayuan",
      "step2Description_LAPSE": "Insurance na kwalipikado ang iyong pamilya",
      "step2Description_QR_CODE": "Insurance na kwalipikado ang iyong pamilya",
      "step2Description_RECURRING_WORK_REQUIREMENT": "Susuriin namin kung sino ang exempted o nasa tamang landas",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "Susuriin namin kung sino ang exempted o nasa tamang landas",
      "step2Description_REDETERMINATION": "Makikipag-ugnayan ang aming call team",
      "step2Description_REDETERMINATION_awareness": "Kasama ang pangunahing impormasyon",
      "step2Description_SELF_PAY_CONVERSION": "Insurance na kwalipikado ang iyong pamilya",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "Suriin ang kasalukuyang katayuan",
      "step2Description_SERVICE_INTRODUCTION_medicare": "Suriin ang kasalukuyang katayuan",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "Suriin ang kasalukuyang katayuan",
      "step2Duration": "5 min",
      "step2Duration_AGING_INTO_MEDICARE": "2 min",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "2 min",
      "step2Duration_LAPSE": "5 min",
      "step2Duration_QR_CODE": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 min",
      "step2Duration_REDETERMINATION": "2 min",
      "step2Duration_SELF_PAY_CONVERSION": "5 min",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "2 min",
      "step2Title": "Hanapin ang mga Opsyon",
      "step2Title_AGING_INTO_MEDICARE": "Suriin ang Insurance",
      "step2Title_AGING_INTO_MEDICARE_awareness": "Suriin ang Insurance",
      "step2Title_LAPSE": "Hanapin ang mga Opsyon",
      "step2Title_QR_CODE": "Hanapin ang mga Opsyon",
      "step2Title_RECURRING_WORK_REQUIREMENT": "Suriin ang mga Requirement",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "Suriin ang mga Requirement",
      "step2Title_REDETERMINATION": "Humingi ng Tulong sa Renewal",
      "step2Title_REDETERMINATION_awareness": "Magdagdag ng Impormasyon ng Sambahayan",
      "step2Title_SELF_PAY_CONVERSION": "Hanapin ang mga Opsyon",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "Suriin ang Insurance",
      "step2Title_SERVICE_INTRODUCTION_medicare": "Suriin ang Insurance",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "Suriin ang Insurance",
      "step3Description": "Kami na ang bahala sa iba!",
      "step3Description_AGING_INTO_MEDICARE": "Kami na ang bahala sa iba!",
      "step3Description_AGING_INTO_MEDICARE_awareness": "Pananatilihin ka naming updated at handa",
      "step3Description_LAPSE": "Kami na ang bahala sa iba!",
      "step3Description_QR_CODE": "Kami na ang bahala sa iba!",
      "step3Description_RECURRING_WORK_REQUIREMENT": "Igagabay ka namin dito",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "Pananatilihin ka naming updated at tutulungan ang pamilya sa requirements",
      "step3Description_REDETERMINATION": "Igagabay ka namin dito",
      "step3Description_REDETERMINATION_awareness": "Pananatilihin ka naming updated at handa",
      "step3Description_SELF_PAY_CONVERSION": "Kami na ang bahala sa iba!",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "Paalalahanan ka namin nang maaga",
      "step3Description_SERVICE_INTRODUCTION_medicare": "Tingnan ang kasama sa plano ng lahat",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "Palawakin ang mga benepisyo",
      "step3Duration": "15 min",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "1 min",
      "step3Title": "I-submit ang Application",
      "step3Title_AGING_INTO_MEDICARE": "I-submit para sa Medicare",
      "step3Title_AGING_INTO_MEDICARE_awareness": "Handa na para sa Medicare",
      "step3Title_LAPSE": "I-submit ang Application",
      "step3Title_QR_CODE": "I-submit ang Application",
      "step3Title_RECURRING_WORK_REQUIREMENT": "I-submit ang mga Requirement",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "Mauna sa mga Requirement",
      "step3Title_REDETERMINATION": "I-submit ang Renewal",
      "step3Title_REDETERMINATION_awareness": "Mauna sa Renewal",
      "step3Title_SELF_PAY_CONVERSION": "I-submit ang Application",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "Huwag Makalampas sa Deadline",
      "step3Title_SERVICE_INTRODUCTION_medicare": "Suriin ang Iyong mga Benepisyo",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "Tuklasin ang Medicare Options",
      "title": "Handa na bang magkaroon ng insurance ang iyong pamilya?",
      "title_RECURRING_WORK_REQUIREMENT": "Panatilihin nating may insurance ang iyong pamilya",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "Panatilihin nating may insurance ang iyong pamilya",
      "title_REDETERMINATION": "Panatilihin nating may insurance ang iyong pamilya",
      "title_REDETERMINATION_awareness": "Panatilihin nating may insurance ang iyong pamilya",
      "title_SERVICE_INTRODUCTION_medicaid": "Panatilihin nating may insurance ang iyong pamilya",
      "title_SERVICE_INTRODUCTION_medicare": "Panatilihin nating may insurance ang iyong pamilya",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "Panatilihin nating may insurance ang iyong pamilya"
    },
    "notKnowingHowToGetCovered": {
      "option": "Hindi alam kung paano kukuha ng insurance",
      "subtext": "Igagabay ka namin sa eksaktong kailangang gawin para magkaroon ng insurance ang lahat."
    },
    "notKnowingImCovered": {
      "option": "Hindi alam kung sino ang may insurance",
      "subtext": "Maaari naming suriin kung ang lahat ay may insurance at tutulungan kang kumuha kung wala pa.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Susuriin namin ang insurance ng lahat at tutulungan kang kumuha nito.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Susuriin namin ang insurance ng lahat at tutulungan kang kumuha nito.",
      "subtext_REDETERMINATION": "Susuriin namin ang insurance ng lahat at tutulungan kang kumuha nito.",
      "subtext_REDETERMINATION_awareness": "Susuriin namin ang insurance ng lahat at tutulungan kang kumuha nito.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Susuriin namin ang insurance ng lahat at tutulungan kang kumuha nito."
    },
    "paperwork": {
      "option": "Masyadong marami o nakakalitong papeles",
      "subtext": "Kami na ang bahala sa lahat ng papeles — mula sa pagkuha hanggang sa mga renewal.",
      "subtext_SERVICE_INTRODUCTION": "Nagtatrabaho kami para sa provider ng iyong pamilya para mahanap ang pinakamagandang opsyon para sa kalusugan ng lahat."
    },
    "partAB": {
      "option": "Part A & B (Medicare)",
      "subtext": "Hahanapin namin ang pinakamagandang opsyon, sa kasalukuyang plano man o Medicare Advantage (Part C)."
    },
    "partABD": {
      "option": "Part A, B, & D (Medicare + Gamot)",
      "subtext": "Hahanapin namin ang pinakamagandang opsyon para sa lahat."
    },
    "partC": {
      "option": "Part C (Medicare Advantage)",
      "subtext": "Sisiguraduhin naming maayos pa rin ang plano para sa lahat."
    },
    "payingForDoctor": {
      "option": "Pagbabayad para sa doktor at gamot",
      "subtext": "Tutulungan namin ang lahat na mahanap ang insurance na magpapababa ng bayad sa doktor at gamot."
    },
    "somethingElse": {
      "option": "Iba pa",
      "subtext": "Tutulungan namin ang lahat na kumuha ng insurance at panatilihin ito.",
      "subtext_AGING_INTO_MEDICARE": "Igagabay ka namin sa pagkuha ng Medicare — step by step.",
      "subtext_AGING_INTO_MEDICARE_awareness": "Igagabay ka namin sa pagkuha ng Medicare — step by step.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Tutulungan naming manatiling may insurance ang lahat — walang sorpresa.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Tutulungan naming manatiling may insurance ang lahat — walang sorpresa.",
      "subtext_REDETERMINATION": "Laktawan ang nakakalitong papeles. Tutulungan naming manatiling may insurance ang lahat.",
      "subtext_REDETERMINATION_awareness": "Laktawan ang nakakalitong papeles. Tutulungan naming manatiling may insurance ang lahat.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Laktawan ang nakakalitong papeles. Tutulungan naming manatiling may insurance ang lahat.",
      "subtext_SERVICE_INTRODUCTION_medicare": "Sisiguraduhin naming maayos pa rin ang plano para sa lahat."
    },
    "submittingRenewals": {
      "option": "Pagsusumite ng mga renewal",
      "subtext": "Kami na ang bahala sa mga renewal para sa lahat. Sagutin lang ang ilang simpleng tanong."
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "Masyadong maraming Medicare ads at tawag",
      "subtext": "Aalisin namin ang gulo at tutulungan kang mahanap ang tamang plano."
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "Tinutulungan ng Pointcare ang 1.8M+ na pasyente na mahanap at mapanatili ang kanilang health insurance.",
          "firstItem_LAPSE": "Tingnan kung sino ang kwalipikado sa loob ng 5 min",
          "infoIsPrivate": "Ligtas sa amin ang iyong impormasyon",
          "title": "Katuwang ng {{clinicName}} ang Pointcare para tulungan ang iyong pamilya"
        },
        "concerns": {
          "description_LAPSE": "Piliin ang pinakamahalaga sa iyo at ipapakita namin kung paano kami makakatulong.",
          "title_LAPSE": "Ano ang pinakamahirap sa pagkuha ng insurance para sa iyong pamilya?"
        },
        "intro": {
          "description_LAPSE": "Karamihan ng tao ay muling nagiging kwalipikado para sa libre o murang insurance. Tutulungan ka namin sa bawat hakbang.",
          "title_LAPSE": "May kasama sa pamilya mo na nawalan ng {{payerName}} coverage noong <colorEmphasis>{{lapseDate}}</colorEmphasis>. Nandito kami para tulungan silang makuha ulit ang coverage."
        },
        "nextSteps": {
          "step2Description_LAPSE": "Tingnan kung saan kwalipikado ang iyong pamilya"
        },
        "paperwork": {
          "option": "Nakakalitong papeles"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "Nakalimutan ang iyong password?",
    "passwordInputLabel": "Password",
    "passwordInputPlaceholder": "Ilagay ang iyong password",
    "resetPasswordInstructions": "Nagpadala kami ng link para i-reset ang password sa <bold>{{email}}</bold>. Buksan ito upang gumawa ng bagong password.",
    "subtitle": "Pakilagay ang password ng iyong account para magpatuloy.",
    "title": "Ilagay ang iyong password",
    "usernameResetUnavailable": "Hindi maaaring i-reset ang password sa pamamagitan ng email para sa mga username account. Tawagan kami at tutulungan ka namin."
  },
  "profileInformationScreen": {
    "addressComplement": "Apt, Unit, Building (kung mayroon)",
    "checkCoverage": "Suriin ang Pagsusulit ng Insurance",
    "coverageStatus": "Katayuan ng Insurance: {{status}}",
    "dateOfBirth": "Petsa ng Kapanganakan",
    "email": "Email",
    "firstName": "Pangalan",
    "homeAddress": "Address ng Bahay",
    "lastName": "Apelyido",
    "mailingAddress": "Address para sa Sulat",
    "mailingAddressComplement": "Apt, Unit, Gusali, PO Box (opsyonal)",
    "medicaidCaseNumber": "Numero ng kaso sa Medicaid (kung mayroon)",
    "medicaidSubscriberId": "Medicaid Subscriber ID (kung mayroon)",
    "noHomeAddress": "Walang Permanenteng Address",
    "noMailingAddress": "Walang Address para sa Sulat",
    "phoneNumber": "Numero ng Telepono",
    "socialSecurityNumber": "Social Security Number",
    "useDifferentMailingAddress": "Gumamit ng ibang address para sa sulat"
  },
  "recheckEligibilityScreen": {
    "button": "Suriin muli ang Kwalipikasyon",
    "title": "Bago muling suriin ang pagiging kwalipikado, siguraduhing updated ang impormasyon ng mga kasama sa bahay."
  },
  "redeterminationScreen": {
    "addressInformation": "I-update ang Impormasyon sa Address",
    "alreadyMailedForm": "Naipadala na ang form o nagpaplanong ipadala agad",
    "caseNumberDescription": "Gagamitin namin ang iyong numero ng kaso para mas mabilis maisumite ang iyong pag-renew!\n\nHanapin ito sa iyong renewal form o iba pang liham mula sa iyong ahensya ng estado tungkol sa iyong saklaw.",
    "caseNumberDescription_PENDING_FORM": "Gagamitin namin ang iyong numero ng kaso para mas mabilis maisumite ang iyong pag-renew!\n\nHanapin ito sa liham mula sa iyong ahensya ng estado tungkol sa iyong saklaw.",
    "caseNumberLabel": "Numero ng Kaso",
    "caseNumberPlaceholder": "Ilagay ang numero ng kaso",
    "caseNumberTitle": "Idagdag natin ang iyong numero ng kaso (opsyonal)",
    "description": "Pumili ng pinakamagandang opsyon",
    "haventReceivedForm": "Hindi pa nakakatanggap ng form",
    "receivedForm": "Nakakuha ng form at kailangan ng tulong sa pagsagot",
    "returnToDashboard": "Bumalik sa Dashboard",
    "reviewAddress": "Pakisuri at kumpirmahin ang mga address ng tahanan at koreo para sa lahat ng miyembro ng sambahayan. Tinitiyak nito na makakarating ang renewal form sa tamang address.",
    "successDescription": "Naayos na ang iyong renewal. Makikipag-ugnayan kami kung may magbago.",
    "successDescription_CALL_BACK": "Makikipag-ugnayan ang aming team sa loob ng 1-2 araw ng trabaho para tapusin ang iyong pag-renew.",
    "successDescription_PENDING_FORM": "Dapat dumating ang renewal form sa address na nakatala. Bantayan ang sulat, email, at mga text. Sisiguraduhin naming mag-follow up bago ang deadline.",
    "successTitle": "Handa Ka Na!",
    "successTitle_CALL_BACK": "Tatawagan ka namin agad.",
    "successTitle_PENDING_FORM": "Handa Ka Na!",
    "title": "May kasama sa bahay na may renewal ng coverage sa {{date}}."
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "{{total}} renewal ng Medicaid ang naghihintay ng tawag — dapat gawin bago ang {{dates}}. Bantayan ang iyong telepono.",
    "cardAggregated_NOT_STARTED": "{{total}} renewal ng Medicaid ang kailangang simulan.",
    "cardAggregated_PENDING_FORM": "{{total}} form ng renewal ng Medicaid ang malapit nang dumating. Bantayan ang koreo, email, at mga text.",
    "cardCompact_PENDING_FORM": "Darating na ang form ng renewal — dapat gawin bago ang {{date}}",
    "card_CALL_BACK": "May renewal ng Medicaid sa iyong sambahayan na naghihintay ng tawag — dapat gawin bago ang {{date}}. Bantayan ang iyong telepono.",
    "card_NOT_STARTED": "May isang miyembro ng iyong sambahayan na may renewal ng Medicaid na dapat gawin bago ang {{date}}.",
    "card_PENDING_FORM": "May darating na form ng renewal ng Medicaid para sa isang miyembro ng iyong sambahayan — dapat gawin bago ang {{date}}. Bantayan ang koreo, email, at mga text.",
    "due": "Dapat gawin bago ang {{date}}",
    "medicaidRenewals": "Mga Renewal ng Medicaid",
    "noRenewals": "Wala pang renewal.",
    "startRenewal": "Simulan ang renewal",
    "status": "Call Back",
    "status_CALL_BACK": "Hiniling ang tawag",
    "status_COMPLETED": "Tapos na",
    "status_NOT_STARTED": "Hindi pa Nasisimulan",
    "status_PENDING_FORM": "Naghihintay ng Form",
    "title": "Mga Renewal",
    "updateStatus": "I-update ang status"
  },
  "registrationCoverageScreen": {
    "description": "Kayang hanapin ng Pointcare ang iyong kasalukuyang Medicaid insurance gamit ang impormasyong ibibigay mo.",
    "title": "Suriin Natin ang Iyong Insurance"
  },
  "registrationProfileScreen": {
    "description": "Ibigay ang mga detalye ng profile na gagamitin sa mga application."
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "Kumpirmahin ang bagong password",
    "confirmPasswordInputPlaceholder": "Muling ilagay ang bagong password",
    "invalidResetLink": "Ang link sa pag-reset ng password ay hindi wasto o nag-expire na. Mangyaring humiling ng bago.",
    "passwordInputLabel": "Bagong password",
    "passwordInputPlaceholder": "Ilagay ang bagong password",
    "subtitle": "Pumili ng matibay na password na hindi mo pa nagagamit dati.",
    "title": "Gumawa ng bagong password",
    "updatePasswordButton": "I-update ang password"
  },
  "sessionTimedOut": {
    "description": "Para sa iyong seguridad, ni-sign out ka namin dahil hindi ka aktibo. Mag-sign in muli.",
    "loginAgain": "Mag-log In Ulit",
    "title": "Na-sign out ka na"
  },
  "sessionTimeout": {
    "countdown": "{{time}} ang natitira",
    "description": "Mala-sign out ka na dahil hindi ka aktibo. Gusto mo bang manatiling naka-sign in?",
    "logOutNow": "Mag-log Out Na",
    "secureSession": "I-secure ang Session",
    "stayLoggedIn": "Manatiling Naka-log In",
    "title": "Nandiyan ka pa ba?"
  },
  "signatureField": {
    "signaturePrompt": "Iguhit ang iyong lagda"
  },
  "someHouseholdMembersNotUpdated": "Hindi namin ma-save ang mga pagbabago para sa lahat. Pakisuri ang bawat miyembro.",
  "support": {
    "callUs": "Tawagan kami",
    "callUsAt": "Tawagan kami sa <underline>{{phoneNumber}}</underline>"
  },
  "workRequirements": {
    "cardActionCompact_START": "Simulan",
    "cardActionCompact_UPLOAD_DOCUMENTS": "Mag-upload",
    "cardAction_CONTINUE": "Ituloy ang Work Requirements",
    "cardAction_START": "Simulan ang Work Requirements",
    "cardAction_UPLOAD_DOCUMENTS": "Mag-upload ng mga Dokumento",
    "cardCompact": "Medicaid Work Requirements na dapat gawin bago ang {{date}}",
    "card_CONTINUE": "May miyembro ng iyong sambahayan na may Medicaid Work Requirements na dapat gawin bago ang {{date}}. Tapusin ang pagsuri kung sino ang nasa tamang landas o exempted.",
    "card_START": "May miyembro ng iyong sambahayan na may Medicaid Work Requirements na dapat gawin bago ang {{date}}. Suriin kung nasa tamang landas ka o exempted.",
    "card_UPLOAD_DOCUMENTS": "May miyembro ng iyong sambahayan na may Medicaid Work Requirements na dapat gawin bago ang {{date}}. Mag-upload ng mga dokumento para manatili sa tamang landas.",
    "caseNumbers": {
      "description": "Gagamitin namin ang mga numero ng kasong ito para magsumite para sa iyong sambahayan.",
      "descriptionSingle": "Gagamitin namin ang numero ng kasong ito para isumite ang mga dokumento sa trabaho ni {{name}}.",
      "hint": "Hanapin ang mga ito sa liham mula sa iyong ahensya ng estado tungkol sa iyong saklaw.",
      "hintSingle": "Hanapin ito sa liham mula sa ahensya ng estado tungkol sa saklaw ni {{name}}.",
      "memberLabel": "{{name}}",
      "title": "Idagdag natin ang mga numero ng kaso ng iyong sambahayan (opsyonal)",
      "titleSingle": "Idagdag natin ang numero ng kaso ni {{name}} (opsyonal)"
    },
    "confirmation": {
      "completedDescription": "Susuriin ito ng aming team at makikipag-ugnayan kami kung may kailangan pa kami.",
      "completedTitle": "Binabati kita, nakumpleto mo na ang <label>Work Requirements</label>",
      "description": "Pakitandaang kumpletuhin ang iyong mga requirement bago ang iyong renewal sa {{date}}.",
      "title": "Kasalukuyang isinasagawa ang <label>Work Requirements</label>",
      "uploadsHint": "Maaari mong tapusin ang mga upload mula sa Dashboard kapag nagbukas na ang mga susunod na buwan."
    },
    "due": "Dapat gawin bago ang <bold>{{date}}</bold>",
    "exemptions": {
      "description": "Piliin ang lahat ng naaangkop",
      "groups": {
        "BENEFITS_AND_COVERAGE": "Mga benepisyo at coverage",
        "CAREGIVING": "Pag-aalaga",
        "HEALTH_AND_RECOVERY": "Kalusugan at paggaling",
        "LIFE_SITUATIONS": "Mga sitwasyon sa buhay"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "Magulang o tagapag-alaga ng batang edad 13 pababa",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "Tagapag-alaga ng taong may kapansanan",
        "FOSTER_YOUTH_UNDER_26": "Foster youth o dating foster youth na wala pang 26 taong gulang",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "Nasa kulungan o bilangguan, o nakalaya sa nakalipas na 90 araw",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "Nasa programa ng paggamot sa droga o alak",
        "MEDICALLY_FRAIL": "Mahina ang kalusugan (medically frail)",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "Nakakatugon na sa mga work requirement ng SNAP/TANF",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "Hindi naka-enroll o hindi kwalipikado sa Medicare",
        "PREGNANT_OR_POSTPARTUM": "Buntis o bagong panganak (hindi hihigit sa 12 buwan)",
        "TRIBAL_MEMBER": "Miyembro ng tribong Native American na kinikilala ng pederal na pamahalaan",
        "VETERAN_100_PERCENT_DISABILITY": "Beterano na may kabuuang (100%) disability rating"
      },
      "title": "Naaangkop ba ang alinman sa mga exemption na ito?"
    },
    "hours": {
      "communityService": "Serbisyo sa komunidad",
      "description_completed": "Idagdag ang mga natapos na oras ni {{name}} para sa {{month}}. Iwanang blangko kung wala.",
      "description_expected": "Idagdag ang mga inaasahang oras ni {{name}} para sa {{month}}. Iwanang blangko kung wala.",
      "employment": "Trabaho",
      "employmentHint": "Ilagay ang oras at buwanang sahod. Iko-convert namin ang sahod sa oras at bibilangin ang mas mataas para sa requirement.",
      "hoursPerMonth": "oras / buwan",
      "jobTraining": "Pagsasanay sa trabaho",
      "payPerMonth": "$ / buwan",
      "school": "Paaralan / apprenticeship",
      "title": "Mag-ulat ng Oras para kay {{name}}",
      "totalHours": "Kabuuang oras",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "Piliin ang lahat ng naaangkop, o magpatuloy kung wala.",
      "everyone": "Lahat ng narito",
      "title": "Sino ang kumikita ng ${{amount}} o higit pa kada buwan?",
      "titleSingle": "Kumikita ba si {{name}} ng ${{amount}} o higit pa kada buwan?"
    },
    "medicaidWorkRequirements": "Medicaid Work Requirements",
    "nextSteps": {
      "complete": "{{completed}} ng {{total}} ang tapos na",
      "description": "Narito ang kailangang i-submit ng bawat tao para mapanatili ang kanilang coverage.",
      "needsMoreHours": "Kailangan ng {{hours}} pang oras / buwan",
      "offrampDescription": "Para mapanatili ang health coverage, kailangang makumpleto ang {{hours}} oras ng mga aprubadong aktibidad kada buwan. Maaaring kasama rito ang trabaho, pagsasanay sa trabaho, paaralan, apprenticeship, at/o serbisyo sa komunidad.",
      "opensOn": "Magbubukas sa {{date}}",
      "proofOfExemption": "Katibayan ng Exemption",
      "proofOfWork": "Katibayan ng Trabaho ({{month}})",
      "reasonHours": "Nag-ulat ng {{hours}} oras / buwan",
      "reasonIncome": "Kumikita ng ${{amount}} o higit pa kada buwan",
      "reportedOf": "Nag-ulat ng {{hours}} sa {{required}} oras / buwan",
      "status_EXEMPT": "Exempted",
      "status_MEETS_REQUIREMENTS": "Nakakatugon sa mga requirement",
      "title": "Mga Susunod na Hakbang sa <label>Work Requirements</label>",
      "volunteerOpportunities": "Mga Oportunidad sa Pagboboluntaryo"
    },
    "noWorkRequirements": "Walang work requirement para sa iyong sambahayan.",
    "progress_ACTION_NEEDED": "Kailangang kumilos",
    "progress_COMPLETED": "Tapos na",
    "progress_UP_TO_DATE": "Updated",
    "recheck": "Suriin Muli ang Work Requirements",
    "sectionTitle": "Mga work requirement",
    "whatAreDescription": "Isang bagong pederal na batas ang nag-aatas sa ilang adult sa Medicaid na magtrabaho, magsanay para sa trabaho, pumasok sa paaralan, o magboluntaryo nang {{hours}} oras/buwan. Para lang ito sa mga adult na edad {{minAge}} hanggang {{maxAge}}.",
    "who": {
      "checkAll": "Suriin ang lahat ng miyembro ng sambahayan",
      "noEligibleMembers": "Walang miyembro ng iyong sambahayan na nasa edad {{minAge}} hanggang {{maxAge}}, kaya walang kailangang suriin.",
      "question": "<bold>Sino ang gusto mong suriin? Titingnan namin kung nasa tamang landas sila o exempted at tutulungan ka namin mula roon.</bold>",
      "title": "Suriin ang Sambahayan para sa Status ng <label>Work Requirements</label>"
    }
  }
}
